
export const ValidateLogisticStationInput = (logisticStation, _createErrorMessage) => {
  if (!logisticStation) {
    _createErrorMessage("77");
    return false;
  }

  return true;
};
  